export const getId = (action: string, name: string) => `block-actions-${action}-${name}`;
